import { getAxiosInstance } from "../../../np-rest/rest";
import restCrudActions from '../../../np-crud/store/restCrudActions'
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'securaze-tools',
    pluginName: 'IMPORT_EXPORT',
    entityName: 'SECURAZE_TOOLS',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch securaze action creators
export const fetchSecurazeToolInit = () => {
    return crudActions.fetchInit();
};
export const fetchSecurazeToolStart = () => {
    return crudActions.fetchStart();
};
export const fetchSecurazeToolSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchSecurazeToolFail = () => {
    return crudActions.fetchFail();
};

export const fetchSecurazeToolsCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchSecurazeToolStart());
        try {
            let countRes = await rest.post("/securaze-tools/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchSecurazeToolSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchSecurazeToolFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch securaze tools."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchSecurazeToolFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch securaze tools."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};

export const fetchSecurazeTools = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchSecurazeToolStart());
        try {
            let listRes = await rest.post("/securaze-tools/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchSecurazeToolSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchSecurazeToolFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchSecurazeToolFail());

            return { data: [] };
        }
    }
};
// Load Securaze Tool action creators
export const loadSecurazeToolInit = () => {
    return crudActions.loadInit();
};
export const loadSecurazeToolStart = () => {
    return crudActions.loadStart();
};
export const loadSecurazeToolSuccess = loadedSecurazeTool => {
    return crudActions.loadSuccess(loadedSecurazeTool);
};
export const loadSecurazeToolFail = error => {
    return crudActions.loadFail(error);
};
export const loadSecurazeTool = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};
export const uploadProgress = (data) => {
    return {
        type: 'SECURAZE_TOOLS|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart
    };
};


// Create Securaze Tool  action creators
export const createSecurazeToolInit = () => {
    return crudActions.createInit();
};
export const createSecurazeToolStart = () => {
    return crudActions.createStart();
};
export const createSecurazeToolSuccess = createdSecurazeTool => {
    return crudActions.createSuccess(createdSecurazeTool);
};
export const createSecurazeToolFail = error => {
    return crudActions.createFail(error);
};

export const createNewSecurazeTool = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(uploadProgress({ progress: null, loadSize: null, maxSize: null, snackStart: true }))
        dispatch(createSecurazeToolInit());
        try {
            const config = {
                onUploadProgress: progressEvent => {
                    dispatch(uploadProgress({ progress: Math.round((progressEvent.loaded * 100) / data.get('File').size), loadSize: Math.round((progressEvent.loaded / 1048576)), maxSize: Math.round((progressEvent.total / 1048576)), snackStart: true }))
                }
            }
            dispatch(createSecurazeToolStart());

            let res = await rest.post('securaze-tools/create', data, config);
            if (res.data.status === 200) {
                dispatch(createSecurazeToolSuccess());

                snackActions.snackBar({
                    message: `${res && res.data && res.data.message ? res.data.message : 'Successfully created securaze tool'}`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.status === 200;

            }
            else {
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: true }))
                dispatch(createSecurazeToolFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: true }))
            dispatch(createSecurazeToolFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}

// Edit Securaze Tool  action creators
export const editSecurazeToolInit = () => {
    return crudActions.editInit();
};
export const editSecurazeToolStart = () => {
    return crudActions.editStart();
};
export const editSecurazeToolSuccess = editedSecurazeTool => {
    return crudActions.editSuccess(editedSecurazeTool);
};
export const editSecurazeToolFail = error => {
    return crudActions.editFail(error);
};

export const editSecurazeTool = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editSecurazeToolStart());
        try {
            let res = await rest.post('/securaze-tools/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated securaze tool.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editSecurazeToolFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit securaze tool."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit securaze tool."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editSecurazeToolFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete securaze tools 
export const bulkDeleteSecurazeToolsInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteSecurazeToolsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteSecurazeToolsSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteSecurazeToolsFail = error => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteSecurazeTools = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteSecurazeToolsStart());
        try {
            let res = await rest.post('/securaze-tools/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteSecurazeToolsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted securaze tools.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteSecurazeToolsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete securaze tools."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete securaze tools."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteSecurazeToolsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const ClearStateCreate = () => {
    return ({
        type: 'CLEAR_STATE_CREATE',
    });
}